import {
  EditNoteOutlined,
  LockOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';
import { ReactElement } from 'react';
import { AccessLevelModel } from 'shared/domain/issue/mapping/accessLevel/model/types';

export function getAccessLevelIcon(
  userAccessLevel: AccessLevelModel,
  disabled: boolean
): ReactElement {
  const color = disabled ? 'disabled' : 'inherit';
  const size = 'small';
  switch (userAccessLevel) {
    case AccessLevelModel.NONE:
      return <LockOutlined fontSize={size} color={color} />;
    case AccessLevelModel.READ:
      return <VisibilityOutlined fontSize={size} color={color} />;
    case AccessLevelModel.EDIT:
      return <EditNoteOutlined fontSize={size} color={color} />;
  }
}
